var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUp1Icon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22012 10.658C3.3611 10.7989 3.55229 10.8781 3.75163 10.8781C3.95098 10.8781 4.14217 10.7989 4.28315 10.658L8.00454 6.93662L11.7259 10.658C11.8677 10.795 12.0576 10.8707 12.2547 10.869C12.4519 10.8673 12.6404 10.7882 12.7798 10.6488C12.9192 10.5095 12.9983 10.3209 13 10.1238C13.0017 9.92666 12.9259 9.73676 12.789 9.59497L8.53606 5.34206C8.39508 5.20112 8.20389 5.12195 8.00454 5.12195C7.80519 5.12195 7.614 5.20112 7.47302 5.34206L3.22012 9.59497C3.07918 9.73595 3 9.92714 3 10.1265C3 10.3258 3.07918 10.517 3.22012 10.658Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp1Icon);
export default __webpack_public_path__ + "static/media/Up1Icon.14600036fbd6f67ecf919cb62baf4390.svg";
export { ForwardRef as ReactComponent };